module.exports = {
  //-- SITE SETTINGS -----
  author: "@kaischwabe",
  siteTitle: "Kai Schwabe | Portfolio",
  siteShortTitle: "KS", // Used as logo text in header, footer, and splash screen
  siteDescription:
    "Kai Schwabe is a founder and product operator building ventures, products, and marketplaces from Munich.",
  siteUrl: "https://kai-schwabe.com",
  siteLanguage: "en_US",
  siteIcon: "content/favicon.png", // Relative to gatsby-config file
  seoTitleSuffix: "Kai Schwabe", // SEO title syntax will be e.g. "Imprint - {seoTitleSuffix}"

  // -- THEME SETTINGS -----
  colors: {
    lightTheme: {
      primary: "#000000",
      secondary: "rgba(20, 189, 235, 0.3)",
      tertiary: "#F2F2F2",
      text: "#000000",
      subtext: "#555555",
      background: "#FFFFFF",
      card: "#FFFFFF",
      scrollBar: "rgba(0, 0, 0, 0.5)",
      boxShadow: "rgba(0, 0, 0, 0.16)",
      boxShadowHover: "rgba(0, 0, 0, 0.32)"
    },
    darkTheme: {
      primary: "#FAFAFA",
      secondary: "rgba(20, 189, 235, 0.3)",
      tertiary: "#252525",
      text: "rgba(255, 255, 255, 0.87)",
      subtext: "#AAAAAA",
      background: "#121212",
      card: "#1C1C1C",
      scrollBar: "rgba(255, 255, 255, 0.5)",
      boxShadow: "rgba(0, 0, 0, 0.16)",
      boxShadowHover: "rgba(0, 0, 0, 0.32)"
    }
  },
  fonts: {
    primary: "Roboto, Arial, sans-serif"
  },

  //-- ARTICLES SECTION SETTINGS -----
  // You can create your own Medium feed with this rss to json converter: https://rss2json.com/
  // To access your Medium RSS feed, just replace this url with your username: https://medium.com/feed/@{yourname}
  mediumRssFeed:
    "https://api.rss2json.com/v1/api.json?rss_url=https%3A%2F%2Fmedium.com%2Ffeed%2F%40konstantinmuenster",
  shownArticles: 3,

  //-- SOCIAL MEDIA SETTINGS -----
  // There are icons available for the following platforms:
  // Medium, GitHub, LinkedIn, XING, Behance
  socialMedia: [
    {
      name: "Linkedin",
      url: "http://linkedin.kai0711er.com"
    },
    {
      name: "Github",
      url: "http://github.kai0711er.com"
    },
    {
      name: "Behance",
      url: "https://www.behance.net/kai-schwabe"
    }
  ],

  //-- NAVIGATION SETTINGS -----
  navLinks: {
    menu: [
      {
        name: "About me",
        url: "/#about"
      },
      {
        name: "Capabilities",
        url: "/#skills"
      },
      {
        name: "Projects",
        url: "/#projects"
      }
    ],
    button: {
      name: "Contact",
      url: "/#contact"
    }
  },
  footerLinks: [
    {
      name: "Privacy",
      url: "/privacy"
    },
    {
      name: "Imprint",
      url: "/imprint"
    }
  ]
};
